export const APPOINTMENT_APPLY_TABLE_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  // {
  //   displayName: "BLOCK",
  //   key: "block",
  // },
  {
    displayName: "ORGANIZATIONAL STRUCTURE",
    key: "organizationalStructure",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const APPOINTMENT_APPLY_DISTRICT_TABLE_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  {
    displayName: "DISTRICT",
    key: "district",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const APPOINTMENT_APPLY_CHAPTER_TABLE_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  {
    displayName: "CHAPTER",
    key: "chapter",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const APPOINTMENT_APPLY_REGION_TABLE_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  {
    displayName: "REGION",
    key: "region",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const APPOINTMENT_APPLY_ZONE_TABLE_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  {
    displayName: "ZONE",
    key: "zone",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const APPOINTMENT_REVIEW_TABLE_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  // {
  //   displayName: "BLOCK",
  //   key: "block",
  // },
  {
    displayName: "ORGANIZATIONAL STRUCTURE",
    key: "organizationalStructure",
  },
  {
    displayName: "POSITION",
    key: "currentPosition",
  },
  // {
  //   displayName: "APPLICATION TYPE",
  //   key: "applicationType",
  // },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const APPOINTMENT_APPROVAL_TABLE_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  // {
  //   displayName: "BLOCK",
  //   key: "block",
  // },
  {
    displayName: "ORGANIZATIONAL STRUCTURE",
    key: "organizationalStructure",
  },
  {
    displayName: "POSITION",
    key: "currentPosition",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const APPOINTMENT_INTERVIEW_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  // {
  //   displayName: "BLOCK",
  //   key: "block",
  // },
  {
    displayName: "ORGANIZATIONAL STRUCTURE",
    key: "organizationalStructure",
  },
  {
    displayName: "POSITION",
    key: "currentPosition",
  },
  {
    displayName: "INTERACTION ON",
    key: "interviewedOn",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];
export const APPOINTMENT_PROPOSE_APPLICATION_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  // {
  //   displayName: "BLOCK",
  //   key: "block",
  // },
  {
    displayName: "ORGANIZATIONAL STRUCTURE",
    key: "organizationalStructure",
  },
  {
    displayName: "POSITION",
    key: "currentPosition",
  },
  // {
  //   displayName: "INTERACTION ON",
  //   key: "interviewedOn",
  // },
  {
    displayName: "ACTION",
    key: "action",
  },
];
export const APPOINTMENT_SECOND_APPROVAL_APPLICATION_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  // {
  //   displayName: "BLOCK",
  //   key: "block",
  // },
  {
    displayName: "ORGANIZATIONAL STRUCTURE",
    key: "organizationalStructure",
  },
  {
    displayName: "POSITION",
    key: "currentPosition",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];
export const APPOINTMENT_PROPOSE_MARK_APPLICATION_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  // {
  //   displayName: "BLOCK",
  //   key: "block",
  // },
  {
    displayName: "ORGANIZATIONAL STRUCTURE",
    key: "organizationalStructure",
  },
  {
    displayName: "POSITION",
    key: "currentPosition",
  },
  {
    displayName: "INTERACTION ON",
    key: "interviewedOn",
  },
  {
    displayName: "STATUS",
    key: "status",
  },
  // {
  //   displayName: "ACTION",
  //   key: "action",
  // },
];

export const LIST_OF_DISTRICT_SPLIT_COL = [
  {
    displayName: "Structure Id",
    key: "id",
  },
  {
    displayName: "DISTRICT",
    key: "structure",
  },
  {
    displayName: "PARENT",
    key: "parent",
  },
  // {
  //   displayName: "PARENT STRUCTURE LEVEL",
  //   key: "division",
  // },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const ANNOUNCEMENT_CYCLE_COL = [
  {
    displayName: "MODULE",
    key: "module",
  },
  {
    displayName: "STRUCTURE LEVEL ",
    key: "structureLevel",
  },
  {
    displayName: "EXAM LEVEL ",
    key: "examLevel",
  },
  {
    displayName: "START DATE",
    key: "startDate",
  },
  {
    displayName: "END DATE",
    key: "endDate",
  },
  {
    displayName: "EXAM DATE",
    key: "examDate",
  },
  {
    displayName: "CREATED BY",
    key: "createdBy",
  },
  {
    displayName: "ACTIVE",
    key: "active",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const DIRECT_APPOINTMENT_COL = [
  {
    displayName: "DIVISION",
    key: "division",
  },
  {
    displayName: "POSITION",
    key: "position",
  },
  {
    displayName: "APPOINTED MEMBER",
    key: "appointedMemberName",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const UHG_DIRECT_APPOINTMENT_COL = [
  {
    displayName: "POSITION",
    key: "position",
  },
  {
    displayName: "APPOINTED MEMBER",
    key: "appointedMemberName",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const VOTING_TABLE_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  {
    displayName: "STRUCTURE LEVEL",
    key: "structureLevel",
  },
  {
    displayName: "DID COMMITTEE MEET",
    key: "ques1",
  },
  {
    displayName: "DID YOU PARTICIPATE",
    key: "ques2",
  },
  {
    displayName: "DO YOU APPROVE APPOINTMENT",
    key: "ques3",
  },
  {
    displayName: "STATUS",
    key: "status",
  },
  {
    displayName: "REMARKS",
    key: "remarks",
  },
];

export const APPOINTMENT_TRACKING_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "CONTACT INFO",
    key: ["phone", "email"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  // {
  //   displayName: "BLOCK",
  //   key: "block",
  // },
  {
    displayName: "ORGANIZATIONAL STRUCTURE",
    key: "organizationalStructure",
  },
  {
    displayName: "POSITION",
    key: "currentPosition",
  },
  {
    displayName: "STATUS",
    key: "status",
  },
  {
    displayName: "ACTION",
    key: "action",
  },
];

export const HIDE_VOTING_TABLE_COL = [
  {
    displayName: "MEMBER ID",
    key: "id",
  },
  {
    displayName: "MEMBER NAME",
    key: ["memberName", "memberAddress"],
  },
  {
    displayName: "DIVISION",
    key: "division",
  },
  {
    displayName: "STRUCTURE LEVEL",
    key: "structureLevel",
  },
  {
    displayName: "STATUS",
    key: "status",
  },
];
